import {
  initialState as alcoholInitialState,
  syncSetData as alcoholSyncSetData,
} from "./slices/alcoholSlice";
import {
  initialState as userInitialState,
  syncSetData as userSyncSetData,
} from "./slices/userSlice";
import {
  initialState as locationInitialState,
  syncSetData as locationSyncSetData,
} from "./slices/locationSlice";
import {
  initialState as ownItemsInitialState,
  syncSetData as ownItemsSyncSetData,
} from "./slices/ownItems";

export const resetAllSyncedData = (dispatch) => {
  dispatch(
    userSyncSetData({ revision: null, newData: userInitialState } as any)
  );
  dispatch(
    alcoholSyncSetData({
      revision: null,
      newData: alcoholInitialState,
    } as any)
  );
  dispatch(
    locationSyncSetData({
      revision: null,
      newData: locationInitialState,
    } as any)
  );
  dispatch(
    ownItemsSyncSetData({
      revision: null,
      newData: ownItemsInitialState,
    } as any)
  );
};
